import { render, staticRenderFns } from "./RTBF.vue?vue&type=template&id=74b9b716&scoped=true"
import script from "./RTBF.vue?vue&type=script&lang=ts"
export * from "./RTBF.vue?vue&type=script&lang=ts"
import style0 from "./RTBF.vue?vue&type=style&index=0&id=74b9b716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9b716",
  null
  
)

export default component.exports